export const CONF = {
  // WEBTITLE: 'CME', NAME: 'CME', SERVER: ' http://127.0.0.1:8000', CURRENCY:'CNY', CURR_SYMBOL:'￥',LANG:'cn',
  WEBTITLE: 'CME', NAME: 'CME', SERVER: 'https://api.jp-savings.shop', CURRENCY:'CNY', CURR_SYMBOL:'USDT ',LANG:'jap',
}

export const API_SERVER = CONF.SERVER
export const APP_INFO = {
    NAME: CONF.NAME,
    WEBTITLE: CONF.WEBTITLE,
    VERSION: '1.0.0',
    APP: 'wap',
    MOBILEPRE:'91'
}
